import { z } from 'zod';
import {
  createModel,
  imageWithUploadSchema,
  itemTypeSchema,
  partySchema,
  temperatureSchema,
} from '../../common';
import { dateSchema, nameSchema } from '../../validation';
import { itemPreferencesSchema } from './item.preferences.model';

/** `item db model` */
export const ItemSchema = createModel({
  /** name of the item */
  name: nameSchema,
  description: nameSchema.optional(),

  /**  instructions on how load/unload items or anything the user wants to add */
  instructions: nameSchema.optional(),

  /** the type of item such as food/medical/etc */
  type: itemTypeSchema,

  /** the temperature needed for the item */
  temperature: temperatureSchema,

  /** preferences */
  preferences: itemPreferencesSchema,

  /** item images  */
  images: z.array(imageWithUploadSchema).default([]),

  /** the last time the item has been ordered */
  orderedLastTime: dateSchema.optional(),
  /**
   * the organization that this item belongs to.
   */
  org: partySchema,
});

/** `item db model` */
export type Item = z.infer<typeof ItemSchema.model>;
export type ItemData = z.infer<typeof ItemSchema.data>;
export type ItemPartial = z.infer<typeof ItemSchema.partial>;
